export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8450.0aea0263.jpg";